import { forwardRef } from "react";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';


export function MonthYearPicker({ selectedDate, setSelectedDate }) {
  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        dateFormat="MMMM yyyy"
        showMonthYearPicker
        locale="en"
        customInput={<CustomInput />} 
      />
    </div>
  );
}

const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <button 
    className="border-0 bg-transparent text-[#668fca] text-4xl" 
    onClick={onClick}
    ref={ref} // <--- This is crucial. It connects react-datepicker to the DOM button
  >
    {value}
  </button>
));